// FILE 20: src/components/catalog/ProductGrid.js
import React from 'react';
import ProductCard from './ProductCard';
import './ProductGrid.css';

/**
 * @param {Array}    products       - filtered list of product objects
 * @param {function} onViewDetails  - passed to each ProductCard
 */
export default function ProductGrid({ products, onViewDetails }) {
  if (!products || products.length === 0) {
    return (
      <div className="product-grid__empty">
        <p>No products found matching your criteria.</p>
        <p>Try a different search term or category.</p>
      </div>
    );
  }

  return (
    <div className="product-grid">
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          onViewDetails={onViewDetails}
        />
      ))}
    </div>
  );
}
